const normalizePath = (path: string): string => decodeURIComponent(path)

export default normalizePath
